const RequiredField = () => {
	return <span className='text-red-500 font-bold'>*</span>;
};

export default RequiredField;